export var isReadableStream = function isReadableStream(stream) {
  var _stream$constructor;
  return typeof ReadableStream === "function" && ((stream === null || stream === void 0 ? void 0 : (_stream$constructor = stream.constructor) === null || _stream$constructor === void 0 ? void 0 : _stream$constructor.name) === ReadableStream.name || stream instanceof ReadableStream);
};
export var isBlob = function isBlob(blob) {
  var _blob$constructor;
  return typeof Blob === "function" && ((blob === null || blob === void 0 ? void 0 : (_blob$constructor = blob.constructor) === null || _blob$constructor === void 0 ? void 0 : _blob$constructor.name) === Blob.name || blob instanceof Blob);
};